module.exports = __webpack_public_path__ + "static/media/nutricion-sin-fondo.6ef671fc.png";